import React, { useState } from "react";

const BlogList = ({ blogs }) => {
  const pageSize = 10; // Number of blogs to show per page
  const [visibleBlogs, setVisibleBlogs] = useState(pageSize); // State to track the number of blogs visible
  const [expandedIndex, setExpandedIndex] = useState(null); // State to track the expanded description index

  // Function to handle showing more blogs
  const showMoreBlogs = () => {
    setVisibleBlogs((prev) => prev + pageSize);
  };

  return (
    <div className="container my-4">
      <div className="row">
        {blogs?.slice(0, visibleBlogs).map((blog, index) => (
          <div key={index} className="col-md-6 col-lg-4 mb-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body d-flex flex-column">
                <h5 className="card-title text-primary">
                  <a
                    href={`/#/blogDetail?id=${blog?.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    {blog?.title}
                  </a>
                </h5>
                <p className="card-text text-muted">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: `${blog?.description.slice(0, 50)} `,
                    }}
                  ></span>
                  {blog?.description.length > 50 && (
                    <a
                      href={`/#/blogDetail?id=${blog?.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none text-info"
                    >
                      Show More
                    </a>
                  )}
                </p>
              </div>
              <div className="card-footer bg-white border-0">
                <a
                  href={`/#/blogDetail?id=${blog?.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex align-items-center text-decoration-none text-secondary"
                >
                  <i className="bi bi-chat-right-text me-2"></i>
                  <span>{blog?.comments} comments</span>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Show More button */}
      {visibleBlogs < blogs.length && (
        <div className="text-center">
          <button
            onClick={showMoreBlogs}
            className="btn btn-primary btn-lg mt-3 shadow"
          >
            Show More Blogs
          </button>
        </div>
      )}
    </div>
  );
};

export default BlogList;
